<template>
  <div class="yulinScreen" ref="visualScreen" style="position: relative; z-index: 1">
    <div class="yulinScreenModule">
      <div class="visualScreenTop">
        <visualHead
          ref="vis"
          :title="containerData.top.title"
          :downloadStyle="downloadStyle"
          :downStatus="containerData.top.downStatus"
          @screen="fullscreenchange"
          @downLoadCallBack="downLoadCallBack"
        />
      </div>
      <div class="visualScreenBottom">
        <div class="visualScreenLeft">
          <div
            class="moduleBack"
            :class="[item.className, containerData.left.className[index]]"
            v-for="(item, index) in containerData.left.module"
            :key="index"
          >
            <div class="relative" :style="containerHeight">
              <titleModule
                v-if="!item.status"
                :title="item.title"
                :containerHeight="containerHeight"
                :moreStatus="item.moreStatus"
                @previewMoreReturn="previewMoreReturn(item)"
              />
              <div class="slotStateCls indexJust" :style="containerHeight" v-if="item.slotState"><slot :name="item.slotName"></slot></div>
            </div>
            <div :style="containerData.left.surplus[containerData.left.className[index]]">
              <slot :name="item.className"></slot>
            </div>
          </div>
        </div>
        <div class="visualScreenContent">
          <slot name="contentMod"></slot>
        </div>
        <div class="visualScreenRight">
          <div
            class="moduleBack"
            :class="[item.className, containerData.right.className[index]]"
            v-for="(item, index) in containerData.right.module"
            :key="index"
          >
            <div class="relative" :style="containerHeight">
              <titleModule
                v-if="!item.status"
                :title="item.title"
                :containerHeight="containerHeight"
                :moreStatus="item.moreStatus"
                @previewMoreReturn="previewMoreReturn(item)"
              />
              <div class="slotStateCls indexJust" :style="containerHeight" v-if="item.slotState"><slot :name="item.slotName"></slot></div>
            </div>

            <div :style="containerData.right.surplus[containerData.right.className[index]]">
              <slot :name="item.className"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 加载过程容器 -->
    <div class="loadingContainer indexJust" v-if="containerLoading">
      <loadingModule />
    </div>
    <!-- 应用下载 -->
    <drawerModule ref="deviceDown" title="小牧丁应用下载" :drawerStyle="drawerStyle">
      <template #content>
        <div class="deviceDownCls"><downloadImg></downloadImg></div>
      </template>
    </drawerModule>
  </div>
</template>

<script>
import visualHead from '@/views/businessModule/visualHead.vue';
import titleModule from '@/views/businessModule/titleModule.vue';
import loadingModule from '@/views/businessModule/loading1.vue';
import drawerModule from '@/views/businessModule/drawer.vue';
import downloadImg from '@/views/businessModule/downloadImg.vue'; // APP下载
export default {
  props: {
    // 数据
    containerData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    awerStatus: false,
    // 多级
    multistage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFullScreen: false,
      screenStatus: false,
      containerHeight: {},
      containerLoading: false,
      // 头部
      downloadStyle: {
        right: 0
      },
      drawerStyle: {
        width: '18.375vw',
        height: '21vw',
        position: 'relative',
        top: '50%',
        left: '50%',
        'margin-top': '-10.5vw',
        'margin-left': '-9.18vw'
      }
    };
  },
  components: {
    visualHead,
    titleModule,
    loadingModule,
    drawerModule,
    downloadImg
  },
  created() {
    this.isFullScreen = false;
    this.containerLoading = true;
  },
  mounted() {
    const that = this;
    localStorage.setItem('WhetherToTriggerFullScreen', '');
    let mainBoxHeight = '';
    let mainBoxWidth = '';
    if (document.getElementsByClassName('mainBox')[0]) {
      mainBoxHeight = document.getElementsByClassName('mainBox')[0].clientHeight;
      mainBoxWidth = document.getElementsByClassName('mainBox')[0].clientWidth;
    } else if (document.getElementsByClassName('externalScreenModule')[0]) {
      mainBoxWidth = document.getElementsByClassName('externalScreenModule')[0].clientWidth;
      mainBoxHeight = document.getElementsByClassName('externalScreenModule')[0].clientHeight;
    }
    localStorage.setItem(
      'mainBox',
      JSON.stringify({
        width: mainBoxWidth,
        height: mainBoxHeight
      })
    );

    this.initScreen();

    document.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement) {
        // 进入
        that.$refs.vis.isFullScreen = true;
      } else {
        // 退出
        that.$refs.vis.isFullScreen = false;
      }
      this.$emit('fullBoxScreen', this.$refs.vis.isFullScreen);
    });

    window.onresize = function () {
      const WhetherToTriggerFullScreen = localStorage.getItem('WhetherToTriggerFullScreen');
      if (Number(WhetherToTriggerFullScreen) >= 1 && Number(WhetherToTriggerFullScreen) !== 3) {
        that.$refs.vis.isFullScreen = false;
        localStorage.setItem('WhetherToTriggerFullScreen', '');
        if (Number(WhetherToTriggerFullScreen) === 1) {
          that.fullscreenchange(false);
        } else {
          that.initScreen();
        }
      } else if (Number(WhetherToTriggerFullScreen) === 3) {
        // localStorage.setItem('WhetherToTriggerFullScreen', '');
        // that.$refs.vis.isFullScreen = false;
      } else {
        that.initScreen();
      }
    };
  },
  methods: {
    // 判定是否是全屏
    isFullScreenEvent() {
      return (
        (document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement) !== null
      );
    },
    // 全屏
    fullscreenchange(val) {
      const that = this;
      that.isFullScreen = val;
      that.containerLoading = true;
      that.$emit('isFullScreenCallBank', val);
      // 最新写法
      const isFullScreen = document.fullscreenElement;
      if (isFullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      } else {
        var fullscreen = that.multistage ? this.$parent.$parent.$refs.visualScreen : this.$parent.$refs.visualScreen; // 需要全屏的元素
        if (fullscreen.requestFullscreen) {
          if (fullscreen) fullscreen.requestFullscreen();
        } else if (fullscreen.mozRequestFullScreen) {
          if (fullscreen) fullscreen.mozRequestFullScreen();
        } else if (fullscreen.webkitRequestFullscreen) {
          if (fullscreen) fullscreen.webkitRequestFullscreen();
        } else if (fullscreen.msRequestFullscreen) {
          if (fullscreen) fullscreen.msRequestFullscreen();
        }
      }
      setTimeout(() => {
        if (that.$parent.screenchange()) {
          that.$parent.screenchange(val, false);
        }
        that.initScreen(1);
      }, 500);
    },
    // 设置容器值
    containerSave(_H, _W, cls, parentCls, direction, index) {
      const vw = 0.0525;
      const print = 'vw';
      _W = _W < 380 ? 380 : _W;
      const _curContent = document.getElementsByClassName(cls);
      const _leftContent = document.getElementsByClassName(parentCls);
      _curContent[0].style.height = _H + 'px';
      _curContent[0].style.width = _W * vw + print;
      _leftContent[0].style.width = _W * vw + print;

      const _H0 = this.screenStatus ? 35 : 44;
      this.containerHeight = {
        height: _H0 * vw + print
      };
      this.$emit('containerHeightCallBack', _H, _W);
      if (direction === 'left') {
        this.containerData.left.surplus[this.containerData.left.className[index]] = {
          height: Number(_H) - Number(_H0) + 'px'
        };
      } else {
        this.containerData.right.surplus[this.containerData.right.className[index]] = {
          height: Number(_H) - Number(_H0) + 'px'
        };
      }
      this.downloadStyle = {
        right: (_W - 84 + 19) * vw + print
      };
      this.$emit('screenCalculation', {
        _W: _W,
        _H: _H,
        direction: direction,
        _data: direction === 'left' ? this.containerData.left : this.containerData.right,
        index: index
      });
    },
    // 初始化屏幕计算
    initScreen(t) {
      const that = this;
      const MAINBox = JSON.parse(localStorage.getItem('mainBox'));
      if (!this.isFullScreen) {
        if (document.getElementsByClassName('mainBox')[0])
          document.getElementsByClassName('mainBox')[0].style.height = MAINBox.height + 'px';
        // if (document.getElementsByClassName('externalScreenModule')[0])
        //   document.getElementsByClassName('externalScreenModule')[0].style.height = MAINBox.height + 'px';
      } else {
        // document.getElementsByClassName('mainBox')[0].style.height = document.getElementById('app').clientHeight;
      }
      // if (this.$refs.vis && !t) {
      //   that.containerLoading = true;
      //   this.$emit('fullBoxScreen', this.$refs.vis.isFullScreen);
      // }
      const _containerData = this.containerData;
      const _leftContent = document.getElementsByClassName(_containerData._leftContent);
      const _leftHeight = _leftContent[0].clientHeight;
      const _autoHeight = 1080 - document.getElementsByClassName('visualScreenTop')[0].clientHeight - 19; // 设计稿容器
      const marginHeight = 16 * _containerData.left.className.length;
      let excessiveLeft = (_autoHeight - _leftHeight - marginHeight) / _containerData.left.className.length;
      excessiveLeft = excessiveLeft < 0 ? 0 : excessiveLeft;
      let excessiveLeftW = (_autoHeight - _leftHeight - marginHeight) / 3;
      excessiveLeftW = excessiveLeftW < 0 ? 0 : excessiveLeftW;
      const leftLength = _containerData.left.maxHeight.length;
      let leftHeightTotal = 0;
      _containerData.left.maxHeight.forEach((item, index) => {
        let _H = Number(item) - excessiveLeft;
        const _W = that.containerData._curWidth - excessiveLeftW;
        if (index === leftLength - 1) {
          _H = Number(_leftHeight) - Number(leftHeightTotal) - marginHeight;
        } else leftHeightTotal = leftHeightTotal + _H;
        if (_leftHeight < _autoHeight) {
          that.containerSave(_H, _W, _containerData.left.className[index], _containerData._leftContent, 'left', index);
          that.screenStatus = true;
        } else {
          _H = index === leftLength - 1 ? _H : item;
          that.containerSave(
            _H,
            _containerData._curWidth,
            _containerData.left.className[index],
            _containerData._leftContent,
            'left',
            index
          );
          that.screenStatus = false;
        }
      });
      const marginRightHeight = 16 * _containerData.right.className.length;
      let excessiveRight = (_autoHeight - _leftHeight - marginRightHeight) / _containerData.right.className.length;
      excessiveRight = excessiveRight < 0 ? 0 : excessiveRight;
      let excessiveRightW = (_autoHeight - _leftHeight - marginRightHeight) / 3;
      excessiveRightW = excessiveRightW < 0 ? 0 : excessiveRightW;
      const rightLength = _containerData.right.maxHeight.length;
      let rightHeightTotal = 0;
      _containerData.right.maxHeight.forEach((item, index) => {
        let _H = Number(item) - excessiveLeft;
        const _W = _containerData._curWidth - excessiveLeftW;
        if (index === rightLength - 1) {
          _H = Number(_leftHeight) - Number(rightHeightTotal) - marginRightHeight;
        } else rightHeightTotal = rightHeightTotal + _H;
        if (_leftHeight < _autoHeight) {
          that.containerSave(_H, _W, _containerData.right.className[index], _containerData._rightContent, 'right', index);
          that.screenStatus = true;
        } else {
          _H = index === rightLength - 1 ? _H : item;
          that.containerSave(
            _H,
            _containerData._curWidth,
            _containerData.right.className[index],
            _containerData._rightContent,
            'right',
            index
          );
          that.screenStatus = false;
        }
      });

      that.$nextTick(() => {
        setTimeout(() => {
          that.containerLoading = false;
        }, 500);
      }, 500);
    },
    // title事件
    previewMoreReturn(item) {
      if (!item.event) return false;
      this.$emit(item.event);
    },
    // 下载APP回调
    downLoadCallBack() {
      this.$emit('downLoadEventCallBack');
      this.$nextTick(() => {
        this.$refs.deviceDown.drawerStatus = true;
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/visualization.scss';
</style>



// WEBPACK FOOTER //
// src/views/businessModule/visualization.vue